import Check from "@mui/icons-material/Check";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { Subtitle } from "./StudyManagerShared.styles";
import { BaseTextButton } from "./base.styles";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import Lock from "@mui/icons-material/Lock";
export const StudiesDetailParent = styled.div `
    align-self: stretch;
`;
export const Columns = styled.div `
    display: flex;
    align-self: stretch;
    gap: 24px;
    align-items: flex-start;
`;
export const MainColumn = styled.div `
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 24px;
    padding: 24px 24px 24px 0;
`;
export const Section = styled.section `
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
export const SectionTitleContainer = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;
export const SectionTitleText = styled(Subtitle) `
    flex-grow: 1;
`;
export const SectionText = styled.div `
    white-space: pre-wrap;
`;
const SectionContentBase = styled.div `
    color: ${colors.black_light};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: 0.15px;
`;
export const SectionContentContainer = styled.div `
    & ul {
        margin-top: 0;
        padding-left: 24px;

        & li {
            padding-left: 4px;
        }
    }
`;
export const SectionContent = styled(SectionContentBase) ``;
const StudyContentTypeBase = styled(SectionContentBase) `
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    display: inline;
`;
export const StudyTypeEl = styled(StudyContentTypeBase) `
    span {
        font-weight: ${fontWeights.NORMAL};
        color: ${colors.black_light};
    }
`;
export const SecondColumn = styled.div `
    flex: 1;
    margin-top: 24px;
`;
export const DetailsSection = styled.div `
    display: flex;
    flex-direction: column;
    gap: 24px;
    border: 1px solid ${colors.black_12};
    background-color: ${colors.white_main};
    border-radius: 4px;
    padding: 24px;
    margin-bottom: 24px;
`;
export const SubsectionTitle = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const DetailsLabel = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_main};
    margin-bottom: 4px;
`;
export const DetailsValue = styled.div `
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_light};
`;
export const DetailsNoValue = styled(DetailsValue) `
    font-style: italic;
`;
export const Link = styled(BaseTextButton) ``;
export const TypesOfDataList = styled(FlexRowDiv) `
    gap: 24px;
`;
export const TypesOfDataListColumn = styled(FlexColumnDiv) `
    gap: 8px;
`;
export const TypesOfDataListItem = styled(FlexRowDiv) `
    gap: 4px;
`;
export const TypesOfDataListItemCheck = styled(Check) `
    width: 24px;
    height: 24px;
    color: ${colors.sunset_main};
`;
export const TypesOfDataListItemText = styled(FlexColumnDiv) ``;
export const NotEditable = styled(FlexRowDiv) `
    gap: 4px;
    align-items: center;
`;
export const NotEditableIcon = styled(Lock) `
    width: 16px;
    height: 16px;
    color: ${colors.black_lighter};
`;
